import { Studio } from 'Core/Studio'
import { ContextType, TaskMode } from 'Types/Tasks.types'
import { PAGE_TITLES } from 'Constants/page.constants'
import { StudioProvider } from 'Contexts/StudioContext'
import { useQuestionPreview } from 'Hooks/exams/use-question-preview'
import { Loader } from 'Components/common/Loader/Loader'
import { useTitle } from 'Hooks/use-title'
import { ExamType } from 'Types/Exams.types'

export const ExamPreviewPage = () => {
    useTitle(PAGE_TITLES.EXAM_PREVIEW)

    const { isLoading, data, error } = useQuestionPreview()

    if (!data || isLoading || error) {
        // might want to render a loading state here if needed
        return <Loader title="Loading preview..." />
    }

    const studio = new Studio({
        taskType: data?.assignment.task.type,
        taskConfig: {
            assignment: data?.assignment,
            evaluationInfo: data.evaluation_info,
            //We won't be making a submission for Viewer Mode
            submissionId: 'MockSubmissionId',
            mode: TaskMode.Viewer,
        },
        context: {
            type: ContextType.ExamTask,
            metaData: {
                isTrainingMode: data.exam_info.type === ExamType.TRAINING,
            },
        },
        pluginsConfig: [],
        onNextTask: () => {},
        onExitTask: () => {},
    })

    return (
        <div data-testid="exam-preview-wrapper">
            <StudioProvider value={studio}>{studio.workbench.element}</StudioProvider>
        </div>
    )
}
